import {INIT_SIGNOUT, INIT_POINTS_MASTER_DATA, INIT_PROBLEM, UPDATE_PROBLEM_POINTS, WATCHED_HINT, WATCHED_SOLUTION, UPDATE_PROGRESS_STATE} from '../Actions/actionTypes';

const INIT_STATE = {
    userID: null,
    rules: {},
    points: 25,
    problemPoints: 10
};

const ProblemPoints = (state = INIT_STATE, action) => {

    let newState;
    switch(action.type){
        case INIT_POINTS_MASTER_DATA:
            return {
                ...state,
                userID: action.userID,
                rules: action.ruleSets,
                problemPoints: action.problemPoints
            }
        
        case INIT_PROBLEM:
            return { 
                ...state,
                points: action.problemPoints || 25
            };

        case UPDATE_PROBLEM_POINTS:
            return {
                ...state,
                points: action.modulePoints || 25
            }

        case WATCHED_HINT:
            newState = state;
            if(!action.isPreviouslyCompleted){
                if(action.isCompleted){
                    return newState.rules['WATCHED_HINT'] ? {
                        ...newState,
                        points: newState.points - newState.rules['WATCHED_HINT']
                    } : newState;
                }
            }
            return newState;

        case WATCHED_SOLUTION:
            newState = state;
            if(!action.isPreviouslyCompleted){
                if(action.isCompleted){
                    return newState.rules['WATCHED_SOLUTION'] ? {
                        ...newState,
                        points: newState.points - newState.rules['WATCHED_SOLUTION']
                    } : newState;
                }
            }
            return newState;

        case UPDATE_PROGRESS_STATE:
            newState = state;
            if(!action.isPreviouslyCompleted){
                if(!action.details.problemAlreadyCompleted && action.isCompleted){
                    return newState.rules['PROBLEM_SOLVED'] ? {
                        ...newState,
                        problemPoints: action.details.problemPoints + action.details.modulePoints
                    } : newState;
                }
            }
            return newState;

        case INIT_SIGNOUT:
            return INIT_STATE;

        default:
            return state;
    }
}



export default ProblemPoints;